import { render, staticRenderFns } from "./ReciboRetencao.vue?vue&type=template&id=52073a5a&"
import script from "./ReciboRetencao.vue?vue&type=script&lang=js&"
export * from "./ReciboRetencao.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/links-autenticacao-recibo-credenciamento-contribuintes.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports